import { createSelector } from 'reselect';

import { selectQuotationActiveAbTests } from 'app/store/data/quotation';
import { selectIsOperator } from 'app/store/data/quotationResult';
import { AbTestEnum } from 'app/shared/enums';

export const selectIsMerchCapUpsellAbTestActive = createSelector(
  [selectQuotationActiveAbTests, selectIsOperator],
  (activeAbTests, isOperator) =>
    !isOperator && Boolean(activeAbTests?.includes(AbTestEnum.MerchCapTkUpsell))
);
